// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http } from "../../../../engine/api/http";
import { notification } from "antd";
import { typeAddress } from "../AddresseItem/AddresseHelpers";

const initialState = {
  addresses: [],
  loading: false,
  value: 0,
};

export const getAddresses = createAsyncThunk(
  "addresses/getAddresses",
  async (search, thunkAPI) => {
    const res = await http.get(`/addresses?${search}`);
    return res.data;
  },
);

export const newAddresse = createAsyncThunk(
  "addresses/newAddresse",
  async (payload, thunkAPI) => {
    const res = await http.post("/addresses/new", payload);

    return res.data;
  },
);

export const deleteAddresse = createAsyncThunk(
  "addresses/deleteAddresse",
  async (payload, thunkAPI) => {
    const res = await http.delete(`/addresses/${payload._id}`);
    return res.data;
  },
);

export const updateSaveAddresse = createAsyncThunk(
  "addresses/updateSaveAddresse",
  async (payload, thunkAPI) => {
    const res = await http.patch(`/addresses`, payload);
    return res.data;
  },
);

const addressesSlice = createSlice({
  name: "addresses",
  initialState,
  reducers: {
    clearAddresses: () => {
      return initialState;
    },
    increment: state => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1;
    },
    decrement: state => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
  },
  extraReducers: {
    [getAddresses.pending]: state => {
      state.loading = true;
    },
    [getAddresses.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.addresses = payload;
    },
    [updateSaveAddresse.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [updateSaveAddresse.fulfilled]: (state, { payload }) => {
      state.loading = false;

      state.addresses = state.addresses.map(e => {
        if (e._id === payload._id) {
          return payload;
        } else {
          return e;
        }
      });
      notification.success({
        message: `Adresse Modifiée`,
      });
    },
    [deleteAddresse.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [deleteAddresse.fulfilled]: (state, { payload }) => {
      state.loading = false;
      const deletedId =
        typeof payload === "string" || typeof payload === "number"
          ? String(payload)
          : payload?._id != null
            ? String(payload._id)
            : null;
      const removed = deletedId
        ? state.addresses.find(e => String(e._id) === deletedId)
        : null;
      const copy = deletedId
        ? state.addresses.filter(e => String(e._id) !== deletedId)
        : state.addresses;
      state.addresses = copy;

      const deletedType = removed?.type ?? payload?.type;
      if (deletedType === typeAddress.postal) {
        notification.success({
          message: `Adresse supprimée`,
        });
      }

      if (deletedType === typeAddress.maps) {
        notification.success({
          message: `Lieu supprimé`,
        });
      }
    },
    [newAddresse.pending]: state => {
      state.loading = true;
    },
    [newAddresse.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.addresses.push(payload);

      if (payload.type === typeAddress.postal) {
        notification.success({
          message: `Adresse créée`,
        });
      }

      if (payload.type === typeAddress.maps) {
        notification.success({
          message: `Lieu créé`,
        });
      }
    },
    [getAddresses.rejected]: state => {
      state.loading = false;
    },
  },
});

export const {
  increment,
  decrement,
  incrementByAmount,
  updateUnitOnList,
  clearAddresses,
} = addressesSlice.actions;

export const addressessReducer = addressesSlice.reducer;
